<template>
    <section class="container">
        <div class="briefM">
            <Row class="titleM">
                <!-- <Col span="3" class="text-center">
                    <img class="logo pointer" :src="logoUrl" alt="">
                </Col> -->
                <!-- <Col span="5" offset="1" class="foot-nav">
                    <div class="col-40 text-center nav-cell">
                        <ul>
                            <li class="pointer" @click="tabClick('/')">首页</li>
                            <li class="pointer" @click="tabClick('/Learn')">学习</li>
                            <li class="pointer" @click="tabClick('/Exam')">测试</li>
                        </ul>
                    </div>
                    <div class="col-40 text-center nav-cell">
                        <ul>
                            <li class="pointer" @click="tabClick('/Online')">远程考试</li>
                            <li class="pointer" @click="tabClick('/Rule')">行业法规</li>
                            <li class="pointer" @click="tabClick('/Dynamic')">行业新闻</li>
                            <li class="pointer" @click="tabClick('/DownLoad')">下载中心</li>
                        </ul>
                    </div>
                </Col> -->
                <Col span="6" offset="2" class="" style="margin-left:42%">
                    <div class="flex-row">
                        <div class="col-30 text-left">
                            咨询热线：
                        </div>
                        <div class="col-70 text-left">
                            <div v-for="(telephone, index) in telephoneList" :key="index" :data-id="telephone.id">
                                {{telephone.telephone}}
                            </div>
                        </div>
                        <!--<div class="col-70 text-left">
                            <div>
                                18185787463
                            </div>
                            <div>
                                18185787463
                            </div>
                        </div>-->
                    </div>
                    <div class="text-left time">
                        周一至周五&nbsp;&nbsp;&nbsp;&nbsp;10:30-19:00
                    </div>
                </Col>
                <Col span="5" offset="2" class="qrCode">
                    <div class="flex-row">
                        <!-- <div class="col-45 text-center">
                            <Poptip class="code" trigger="hover" placement="top">
                              <img :src="iosCodeUrl" alt="">
                              <div class="api" slot="content">
                                <img :src="iosCodeUrl" alt="" style="width: 140px;height: 140px;margin: 20px;">
                              </div>
                            </Poptip>
                            <div class="intro">
                                培训学习苹果APP下载
                            </div>
                        </div> -->
                        <!-- <div class="col-45 text-center">
                            <Poptip class="code" trigger="hover" placement="top">
                              <img :src="androidCodeUrl" alt="">
                              <div class="api" slot="content">
                                <img :src="androidCodeUrl" alt="" style="width: 140px;height: 140px;margin: 20px;">
                              </div>
                            </Poptip>
                            <div class="intro">
                                培训学习安卓APP下载
                            </div>
                        </div> -->
                    </div>
                </Col>
            </Row>
            <!-- <div class="LinkM text-center">
                友情链接：
                <span class='Link pointer' v-for="link in linkList" :data-url="link.url" @click="openUrl">
                    {{link.title}}
                </span>
            </div> -->
        </div>
        <div class="copyRightM">
            <div class="copyRight">
                <!-- © ️2005-2019新疆维吾尔自治区安全技术防范行业协会 -->
                <!-- <span>版权所有</span><span @click="openUrl" data-url="http://www.beian.miit.gov.cn/" style="cursor: pointer;">新ICP备17000948号-7</span> -->
            </div>
            <div>
                技术支持：乌鲁木齐天耀伟业信息技术服务有限公司
            </div>
            <div>
                <img class="footerlo" src="../../assets/footerlogo.jpg"></img> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=65010902000303">新公网安备65010602000719号</a>
            </div>
                    <div class="copyRight">
                <!-- © ️2005-2019新疆维吾尔自治区安全技术防范行业协会 -->
                <span>版权所有</span><span @click="openUrl" data-url="https://beian.miit.gov.cn" style="cursor: pointer;">新ICP备17000948号-7</span>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      logoUrl: [],
      iosCodeUrl: [],
      androidCodeUrl: [],
      telephoneList: [],
      linkList: [
        {
          title: "新疆安防协会网",
          url: "http://www.xjafxh.org/",
        },
        {
          title: "乌鲁木齐天耀伟业官网",
          url: "http://www.xjtywy.com/index.html",
        },
        {
          title: "中国安全防范产品行业协会",
          url: "http://xh.21csp.com.cn/",
        },
        {
          title: "天山警网",
          url: "http://www.xjgat.gov.cn/",
        },
        {
          title: "中国安防网",
          url: "http://www.hqps.com/",
        },
        {
          title: "成都安全防范网",
          url: "http://www.21cdaf.com/",
        },
        {
          title: "新疆招投标网",
          url: "http://xinjiang.bidchance.com/",
        },
      ],
    };
  },
  mounted() {
    this.onload();
  },
  methods: {
    onload() {
      //初始化
      var that = this;
      var modelData = {};
      var modelData1 = {};
      var modelData2 = {};
      var modelData3 = {};
      this.$http({
        url: that.webhost + "logo/picture",
        method: "get",
        data: modelData,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.logoUrl = data.data.picture;
        } else {
          that.$Message.error(data.msg);
        }
      }),
        this.$http({
          url: that.webhost + "code/android",
          method: "get",
          data: modelData1,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            that.androidCodeUrl = data.data.picture;
          } else {
            that.$Message.error(data.msg);
          }
        }),
        this.$http({
          url: that.webhost + "code/ios",
          method: "get",
          data: modelData2,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            that.iosCodeUrl = data.data.picture;
          } else {
            that.$Message.error(data.msg);
          }
        }),
        this.$http({
          url: that.webhost + "telephone/telephone",
          method: "POST",
          data: modelData3,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            that.telephoneList = data.data;
          } else {
            that.$Message.error(data.msg);
          }
        });
    },
    openUrl(e) {
      window.open(e.currentTarget.dataset.url);
    },
  },
};
</script>

<style scoped>
.container {
  /*width: 1200px;*/
  min-width: 1200px;
  /*height: 335px;*/
  margin-top: 20px;
  color: #ffffff;
  font-family: "PingFang SC";
}
.foot-nav {
  overflow: hidden;
}
.foot-nav .nav-cell {
  float: left;
}
.briefM {
  background-color: #333333;
  font-size: 17px;
  padding: 20px 0;
}
.logo {
  width: 114px;
  height: 114px;
}
.LinkM {
  width: 97%;
  margin: auto;
  margin-top: 45px;
}
.LinkM span {
  padding: 0 10px;
  position: relative;
}
.LinkM span::after {
  content: "";
  width: 1px;
  height: 17px;
  position: absolute;
  top: 4px;
  right: 0;
  background-color: #fff;
}
.LinkM span:last-child::after,
.copyRight span:last-child::after {
  content: none;
}
.copyRightM {
  background-color: rgba(0, 0, 0, 0.79);
  margin-top: 2px;
  padding: 20px 0;
  font-size: 15px;
  line-height: 25px;
}
.copyRight span {
  padding: 0 12px;
  position: relative;
}
.copyRight span::after {
  content: "";
  width: 1px;
  height: 14px;
  position: absolute;
  top: 4px;
  right: 0;
  background-color: #adadad;
}
ul > li {
  list-style: none;
}
.time {
  margin-top: 12px;
}
.qrCode {
  font-size: 14px;
}
.qrCode .intro {
  width: 84px;
  margin: auto;
}
.qrCode img {
  width: 80px;
  height: 80px;
}
.Nav ul li {
  cursor: pointer;
}
.Nav ul li:hover {
  color: #23b8ff;
}
.footerlo {
  height: 13px;
}
.ivu-col-offset-1 {
  margin-left: 28% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Footer.vue